ui-bank-search-autocomplete {
  display: block;

  .sr-only {
    @include sr-only;
  }

  sd-input {
    position: relative;
    margin: 0 auto;
  }
}
